export enum AppMode {
    Preview = 'PREVIEW_MODE',
    Order = 'ORDER_MODE',
    Editor = 'EDITOR_MODE',
}

export const ALLOWED_URL_MODES: AppMode[] = [AppMode.Preview, AppMode.Order];